module.exports = __webpack_public_path__ + "static/media/社区团购_09.acbdc06d.jpg";